import { render } from "./EmployeesList.vue?vue&type=template&id=1a7011c8&scoped=true&ts=true"
import script from "./EmployeesList.vue?vue&type=script&lang=ts"
export * from "./EmployeesList.vue?vue&type=script&lang=ts"

import "./EmployeesList.vue?vue&type=style&index=0&id=1a7011c8&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7011c8"]])

export default __exports__